// src/pages/financeiro/RecebimentoExclusaoModal.js
import React, { useEffect, useState } from 'react';
import Modal from '../../components/modalForm/StackedBootstrapModal';
import { FaTrashAlt } from 'react-icons/fa';
import { formatCurrency } from '../../utils/numberUtils';

const obterDocumento = (recebimento) => {
    const documentos = recebimento?.documentos || [];
    if (!documentos.length) return 'Sem documento vinculado';
    return documentos.map((documento) => documento.numero
        ? `${documento.modeloDescricao || 'Documento'} ${documento.numero}`
        : `Documento #${documento.notaId}`).join(' / ');
};

const RecebimentoExclusaoModal = ({ show, recebimento, onHide, onConfirm }) => {
    const [justificativa, setJustificativa] = useState('');
    const [processando, setProcessando] = useState(false);

    useEffect(() => {
        if (!show) return;
        setJustificativa('');
        setProcessando(false);
    }, [show, recebimento]);

    const motivo = justificativa.trim();
    const justificativaValida = motivo.length >= 10 && justificativa.length <= 1000;
    const confirmar = async () => {
        if (!recebimento?.id || !justificativaValida) return;
        setProcessando(true);
        try {
            await onConfirm?.(recebimento.id, motivo);
        } catch {
            // A mensagem da API é apresentada pelo contexto de recebimentos.
        } finally {
            setProcessando(false);
        }
    };

    return (
        <Modal show={show} onHide={processando ? undefined : onHide} centered
            backdrop={processando ? 'static' : true} keyboard={!processando} className="confirmacao-exclusao-modal">
            <Modal.Header closeButton={!processando}>
                <Modal.Title>Excluir recebimento #{recebimento?.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="recebimento-exclusao-resumo">
                    <div><span>Cliente</span><strong>{recebimento?.clienteNome || 'Não informado'}</strong></div>
                    <div><span>Valor</span><strong>{formatCurrency(recebimento?.valorTotal)}</strong></div>
                    <div className="documento"><span>Documento</span><strong>{obterDocumento(recebimento)}</strong></div>
                </div>
                <div className="alert alert-warning py-2 mt-3 mb-3">
                    O recebimento e suas parcelas serão excluídos logicamente. A operação ficará registrada na auditoria.
                </div>
                <label className="form-label" htmlFor="justificativa-exclusao-recebimento">Justificativa da exclusão *</label>
                <textarea id="justificativa-exclusao-recebimento" className="form-control" rows="4" maxLength="1000"
                    value={justificativa} onChange={(event) => setJustificativa(event.target.value)}
                    disabled={processando} autoFocus />
                <div className={`recebimento-exclusao-contador ${motivo.length > 0 && motivo.length < 10 ? 'invalido' : ''}`}>
                    {motivo.length}/1000 (mínimo 10 caracteres)
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={onHide} disabled={processando}>Cancelar</button>
                <button type="button" className="btn btn-danger" onClick={confirmar}
                    disabled={processando || !justificativaValida}>
                    <FaTrashAlt /> {processando ? 'Excluindo...' : 'Excluir recebimento'}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default RecebimentoExclusaoModal;
